import { createSlice } from '@reduxjs/toolkit';

const contractsSlice = createSlice({
    name: 'contracts',
    initialState: {
        contractsList: null,
        actualContract: null,
        contractMode: null,
    },
    reducers: {
        setContractsList: (state, action) => {
            state.contractsList = action.payload;
        },
        addContract: (state, action) => {
            state.contractsList = [...state.contractsList, action.payload];
        },
        deleteContractAction: (state, action) => {
            state.contractsList = state.contractsList.filter(contract => contract.id !== action.payload);
        },
        setActualContract: (state, action) => {
            state.actualContract = action.payload;
        },
        setContractMode: (state, action) => {
            state.contractMode = action.payload;
        }
    }
})

export const { setContractsList, addContract, deleteContractAction, setActualContract, setContractMode } = contractsSlice.actions;
export default contractsSlice.reducer;
